export default function VendorManagementDirective() {
  return {
    template: require('./vendor-management.html'),
    controller: 'VendorManagementController',
    controllerAs: 'vendorManagementVM',
    bindToController: true,
    replace: true,
  };
}
